export const INTERFACE_BUSINESS = 'business';
export const INTERFACE_INDIVIDUAL = 'individual';
